var _style, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#20EE82;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.1,150v38.1H150c-21.1,0-38.1-17.1-38.1-38.1s17.1-38.1,38.1-38.1S188.1,128.9,188.1,150 M150.5,86.4 c-35.1-1-64.4,26.6-65.4,61.7s26.6,64.4,61.7,65.4h66.8v-62.8C213.5,115.7,185.5,86.7,150.5,86.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.9,60.1C197.2,17.4,130.3,10.7,79.9,44c1.4,1.6,2.7,3.3,3.6,5.2c47.9-31.4,111.2-25,151.7,15.5 c47.1,47,47.1,123.6,0,170.6s-123.6,47.1-170.7,0C24.2,194.7,17.8,131.4,49.2,83.5c-1.9-1-3.6-2.2-5.2-3.6 C5.3,138.4,21.4,217.3,79.9,256s137.4,22.6,176.1-35.9C289.3,169.7,282.6,102.9,239.9,60.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1,52.1c5-5,13-5,18,0c5,5,5,13,0,18c-5,5-13,5-18,0l0,0C47.2,65.1,47.2,57,52.1,52.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/SC.7646d0f446b0b6b18d748696c40b2958.svg";
export { ForwardRef as ReactComponent };